import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=b52beb40&scoped=true&"
import script from "./nav.vue?vue&type=script&lang=js&"
export * from "./nav.vue?vue&type=script&lang=js&"
import style0 from "./nav.vue?vue&type=style&index=0&id=b52beb40&scoped=true&lang=css&"
import style1 from "./nav.vue?vue&type=style&index=1&id=b52beb40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52beb40",
  null
  
)

component.options.__file = "nav.vue"
export default component.exports